import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const NavItem = ({ icon, label, to, active }) => {
  const navigate = useNavigate();
  return (
    <button className={`nav-link${active ? ' active' : ''}`} onClick={() => navigate(to)}>
      <span style={{ fontSize: 15 }}>{icon}</span>
      {label}
    </button>
  );
};

export default function Layout({ children, title }) {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const p = location.pathname;

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-mark">
            <div className="logo-icon">⬡</div>
            ID System
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section-label">Main</div>
          <NavItem icon="◈" label="Dashboard" to="/" active={p === '/'} />
          <NavItem icon="⊞" label="Projects" to="/projects" active={p.startsWith('/projects')} />
          <NavItem icon="◧" label="Templates" to="/templates" active={p.startsWith('/templates')} />
        </nav>

        <div className="sidebar-footer">
          <div style={{ fontSize: '0.78rem', color: 'var(--text3)', marginBottom: 10, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {user?.email}
          </div>
          <button className="btn btn-ghost btn-sm w-full" onClick={() => { signOut(); navigate('/login'); }} style={{ justifyContent: 'center' }}>
            Sign Out
          </button>
        </div>
      </aside>

      <div className="main">
        <div className="topbar">
          <span className="topbar-title">{title}</span>
          <div className="topbar-actions">
            <span className="badge badge-green">online</span>
          </div>
        </div>
        <div className="page">{children}</div>
      </div>
    </div>
  );
}
